
import { mergeData } from 'vue-functional-data-merge'

import { ThemeMixin } from '../../mixins'

export default ThemeMixin.extend({
  name: 'WeveTextFieldSkeleton',
  functional: true,
  render(h, { data, injections }) {
    return h(
      'div',
      mergeData(data, {
        staticClass: 'app-toggle-skeleton app-form-element-skeleton',
        class: {
          'w-theme--light': injections.theme === 'light',
          'w-theme--dark': injections.theme === 'dark',
        },
      }),
      [
        h('div', {
          staticClass: 'skeleton-element app-toggle-skeleton__label',
        }),
        h('div', {
          staticClass: 'skeleton-element app-toggle-skeleton__element',
        }),
      ],
    )
  },
})
